import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

export default function PendingApprovalCard({
  item,
  busy = false,
  onApprove,
  onReject,
  onReview,
}) {
  if (!item) return null;

  const amountLines = Array.isArray(item.formattedAmount)
    ? item.formattedAmount
    : [item.formattedAmount || "-"];

  return (
    <article className="ai-pending-card">
      <span
        className={`ai-pending-card__icon is-${item.tone || "blue"}`}
        aria-hidden="true"
      >
        {item.iconSrc ? (
          <img src={item.iconSrc} alt="" />
        ) : (
          <FontAwesomeIcon icon={item.icon} />
        )}
      </span>

      <div className="ai-pending-card__content">
        <h4>{item.title}</h4>
        <p>{item.description}</p>
      </div>

      <strong className="ai-pending-card__amount">
        {amountLines.map((amount, index) => (
          <span key={`${amount}-${index}`}>{amount}</span>
        ))}
      </strong>

      {item.priority ? (
        <span
          className={`ai-pending-card__priority ${
            item.priority.toLowerCase().includes("high")
              ? "is-high"
              : "is-medium"
          }`}
        >
          {item.priority}
        </span>
      ) : (
        <span aria-hidden="true" />
      )}

      <div className="ai-pending-card__actions">
        <div className="ai-pending-card__decision-actions">
          <button
            type="button"
            className="ai-pending-card__reject"
            disabled={busy}
            onClick={() => onReject?.(item)}
            aria-label={`Reject ${item.title}`}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <button
            type="button"
            className="ai-pending-card__approve"
            disabled={busy}
            onClick={() => onApprove?.(item)}
            aria-label={`Approve ${item.title}`}
          >
            <FontAwesomeIcon icon={faCheck} />
          </button>
        </div>
        <button
          type="button"
          className="ai-pending-card__review"
          onClick={() => onReview?.(item)}
        >
          {item.reviewLabel || "Review"}
        </button>
      </div>
    </article>
  );
}
